import { render, staticRenderFns } from "./ZoneArrow.vue?vue&type=template&id=5fc45716&scoped=true"
import script from "./ZoneArrow.vue?vue&type=script&lang=js"
export * from "./ZoneArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc45716",
  null
  
)

export default component.exports